import {Record} from 'immutable';

export const ASSIGNEE_TYPE_EMPLOYEE = 'ASSIGNEE_TYPE_EMPLOYEE';
export const ASSIGNEE_TYPE_RELATION = 'ASSIGNEE_TYPE_RELATION';
export const ASSIGNEE_TYPE_ORGANIZATION_PERSON = 'ASSIGNEE_TYPE_ORGANIZATION_PERSON';

const RoleAssignee = Record({
    organizationId: undefined, // Only used for Organization Persons
    assigneeId: undefined,
    loginId: undefined,
    famlyId: undefined,
    roleTargetId: undefined,
    role: null,
    invitations: null, // Only used for Child Contacts
    name: undefined,
    email: undefined,
    image: null,
    assigneeType: undefined,
});

const fromEmployee = employee =>
    new RoleAssignee({
        assigneeId: employee.employeeId,
        loginId: employee.loginId,
        famlyId: employee.famlyId,
        roleTargetId: employee.institutionId,
        role: employee.role,
        name: employee.name.fullName,
        email: employee.email,
        image: employee.image.large,
        assigneeType: ASSIGNEE_TYPE_EMPLOYEE,
    });

const fromEmberEmployee = employee =>
    new RoleAssignee({
        assigneeId: employee.id,
        loginId: employee.loginId,
        famlyId: employee.famlyId,
        roleTargetId: employee.institutionId,
        role: employee.get('role.roleId') ? employee.get('role') : null,
        name: employee.name.fullName,
        email: employee.email,
        image: employee.image.large,
        assigneeType: ASSIGNEE_TYPE_EMPLOYEE,
    });

const fromOrganizationPerson = (organizationPerson, roleTargetId, role) =>
    new RoleAssignee({
        organizationId: organizationPerson.organizationId,
        assigneeId: organizationPerson.organizationPersonId,
        loginId: organizationPerson.loginId,
        famlyId: `Famly.Daycare:OrganizationPerson|${organizationPerson.organizationPersonId}`,
        roleTargetId,
        role,
        name: organizationPerson.name.fullName,
        email: organizationPerson.email,
        image: 'img/empty.jpg',
        assigneeType: ASSIGNEE_TYPE_ORGANIZATION_PERSON,
    });

const getRoleFromRelation = relation => {
    if (relation.invitations.size > 0) {
        return relation.invitations.get(0);
    } else if (relation.roles2.size > 0) {
        return relation.roles2.get(0);
    } else {
        return null;
    }
};

const fromRelation = relation =>
    new RoleAssignee({
        assigneeId: relation.relationId,
        loginId: relation.loginId,
        famlyId: relation.famlyId,
        roleTargetId: relation.childId,
        role: getRoleFromRelation(relation),
        invitations: relation.invitations,
        name: relation.name.fullName,
        email: relation.email,
        image: relation.image.large,
        assigneeType: ASSIGNEE_TYPE_RELATION,
    });

export default {
    default: new RoleAssignee(),
    record: RoleAssignee,
    fromEmployee,
    fromEmberEmployee,
    fromOrganizationPerson,
    fromRelation,
};
